import type { ReactNode, ButtonHTMLAttributes } from 'react';

export const Button = ({
	appearance = 'primary',
	children,
	...restProps
}: IButtonProps) => {
	return (
		<button
			{...restProps}
			className={`${restProps.className ? restProps.className : ''} ${appearance}`}
		>
			{children}
		</button>
	);
};

export interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	appearance?: 'primary' | 'secondary' | 'tertiary';
	children: ReactNode;
	className?: string;
}

export default Button;
